import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.esm.js';
import { useState, useCallback } from 'react';
import fetchContactCardInfo from './api/fetch-contact-card-info.esm.js';
import requestTraining from './api/request-training.esm.js';
import submitFeedback from './api/submit-feedback.esm.js';

var initialApiData = {
  isFetching: true
};
function useSupportModalHandlers(params) {
  var _ref = params || {},
    _ref$apiBasePath = _ref.apiBasePath,
    apiBasePath = _ref$apiBasePath === void 0 ? '' : _ref$apiBasePath,
    _ref$contactId = _ref.contactId,
    contactId = _ref$contactId === void 0 ? 0 : _ref$contactId,
    _ref$locationId = _ref.locationId,
    locationId = _ref$locationId === void 0 ? 0 : _ref$locationId,
    _ref$productMode = _ref.productMode,
    productMode = _ref$productMode === void 0 ? '' : _ref$productMode,
    userAgentString = _ref.userAgentString,
    firstName = _ref.firstName,
    lastName = _ref.lastName;
  var _useState = useState(initialApiData),
    _useState2 = _slicedToArray(_useState, 2),
    contactCardData = _useState2[0],
    setContactCardData = _useState2[1];
  var onRequestContactCardData = useCallback(function () {
    fetchContactCardInfo({
      apiBasePath: apiBasePath,
      request: {
        locationId: locationId
      },
      setContactCardData: setContactCardData
    });
  }, [apiBasePath, locationId, setContactCardData]);
  var onRequestTraining = useCallback(function () {
    requestTraining({
      apiBasePath: apiBasePath,
      request: {
        locationId: locationId,
        productMode: productMode,
        userAgentString: userAgentString,
        firstName: firstName,
        lastName: lastName,
        contactId: contactId
      }
    });
  }, [apiBasePath, contactId, locationId, productMode, userAgentString, firstName, lastName]);
  var onSubmitFeedback = useCallback(function (_ref2) {
    var starRating = _ref2.starRating,
      feedBackText = _ref2.feedBackText;
    submitFeedback({
      apiBasePath: apiBasePath,
      request: {
        productMode: productMode,
        feedBackText: feedBackText,
        starRating: starRating,
        locationId: locationId,
        contactId: contactId,
        userAgentString: userAgentString
      }
    });
  }, [apiBasePath, contactId, locationId, productMode, userAgentString]);
  return {
    contactCardData: contactCardData,
    onRequestContactCardData: onRequestContactCardData,
    onRequestTraining: onRequestTraining,
    onSubmitFeedback: onSubmitFeedback
  };
}

export { useSupportModalHandlers as default };
//# sourceMappingURL=use-support-modal-handlers.esm.js.map
